import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const USE_MOCK_DATA = true;

const MOCK_AUDIT_LOG = [
	{ id: 1, entity_name: "Asset", record_id: "AST-000001", action: "ALLOCATE", performed_by: { fname: "Nimal", lname: "S." }, performed_at: "2025-06-15 09:12" },
	{ id: 2, entity_name: "Asset", record_id: "AST-000006", action: "STATE_CHANGE", performed_by: { fname: "Nimal", lname: "S." }, performed_at: "2025-06-20 14:03" },
	{ id: 3, entity_name: "License", record_id: "Microsoft 365 E3", action: "UPDATE", performed_by: { fname: "Sachini", lname: "W." }, performed_at: "2025-06-18 11:45" },
	{ id: 4, entity_name: "Asset", record_id: "AST-000010", action: "DELETE", performed_by: { fname: "Nimal", lname: "S." }, performed_at: "2025-05-01 16:20" },
];

export const fetchAuditLogList = createAsyncThunk("fetchAuditLogList", async ({ page, limit, filters }) => {
	if (USE_MOCK_DATA) {
		await new Promise((r) => setTimeout(r, 300));
		return { docs: MOCK_AUDIT_LOG, pagination: { page, total: MOCK_AUDIT_LOG.length } };
	}
	const params = new URLSearchParams({ page, limit, entityName: filters?.entityName ?? "" });
	const response = await axiosHttp.get(`assets/audit?${params}`);
	return response.data.data;
});

const AuditLogListSlice = createSlice({
	name: "auditLogListSlice",
	initialState: { isLoading: false, data: null, error: null, page: 1, total: 0 },
	extraReducers: (builder) => {
		builder.addCase(fetchAuditLogList.pending, (state) => { state.isLoading = true; });
		builder.addCase(fetchAuditLogList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.pagination?.page;
			state.total = action.payload.pagination?.total;
		});
		builder.addCase(fetchAuditLogList.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
	},
});

export default AuditLogListSlice.reducer;
